'use client';

import * as React from 'react';
import { CartProvider } from '@/app/context/cart-context';
import { QuotationProvider } from '@/app/context/quotation-context';
import { MessagesProvider } from '@/app/context/messages-context';
// Import but don't use CheckoutProvider globally
import { CheckoutProvider } from '@/app/context/checkout-context';
import LoadingSpinner from './components/LoadingSpinner';
import { Toaster } from 'sonner';

// Fallback component for Suspense
function LoadingFallback() {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-80 flex items-center justify-center z-50">
      <LoadingSpinner size="large" />
    </div>
  );
}

// Main Providers component that wraps content in Suspense
export default function Providers({
  children,
  messages
}: {
  children: React.ReactNode;
  messages: Record<string, unknown>
}) {
  return (
    <MessagesProvider messages={messages}>
      <CartProvider>
        <QuotationProvider>
          {/* Remove the CheckoutProvider from here - we'll add it only to checkout pages */}
          <React.Suspense fallback={<LoadingFallback />}>
            {/* Add Sonner toast container */}
            <Toaster position="top-right" richColors closeButton />
            {children}
          </React.Suspense>
        </QuotationProvider>
      </CartProvider>
    </MessagesProvider>
  );
}